import React from 'react';
import { getStatus } from '../../utlis/sellerStatus';
import Button from './Button/Button';
import './selectedPopup.css';

const SelectedRegisteredPopup = ({ seller, onClose, handleEditClick, selectedItem }) => {
  if (!seller) return null;

  return (
    <div className="popup">
    {/* <div className="popup-overlay"> */}
     {/* <div className="popup-content"> */}
      <div className="popup-content" onClick={e => e.stopPropagation()}>
        <div className="popup-header">
          <Button onClick={onClose} className="close-btn top-right" title="Close">×</Button>
        </div>
        <div className="popup-body">
          <div className="popup-grid">
            {/* Details Section */}
              <div className="details-section">
                <h4>Seller Details</h4>
                <p><strong>Name:</strong> {seller.firstName} {seller.lastName}</p>
                <p><strong>Company:</strong> {seller.companyName}</p>
                <p>
                  <strong>Website:</strong>{" "}
                  {seller.website ? (
                    <a
                      href={seller.website.startsWith("http") ? seller.website : `https://${seller.website}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {seller.website}
                    </a>
                  ) : (
                    "-"
                  )}
                </p>    
                <p><strong>City:</strong> {seller.city}, {seller.state}</p>
          
              </div>

              {/* Contact Information */}
              <div className="contact-info-section">
                <h4>Contact Information</h4>
                <p><strong>Phone:</strong> {seller.phoneNumber}</p>
                <p><strong>Email:</strong> {seller.emailID}</p>
              </div>

              {/* Technical Information */}
              <div className="technical-info-section">
                <h4>Subscription Information</h4>
                  <p><strong>PAN:</strong> {seller.pan || '-'}</p>
                  <p><strong>GST:</strong> {seller.gst}</p>
                  <p>
                    <strong>Subscription:</strong>{" "}
                    {seller.package} - {seller.years} {seller.years === 1 ? "year" : "years"}
                  </p>        
                  <p><strong>Password:</strong> {seller.passwrd}</p>
                <p><strong>Start Date:</strong> {seller.startDate}</p>
                <p><strong>End Date:</strong> {seller.endDate}</p>
                <p>
                  <strong>Status:</strong>{" "}
                  <span
                    style={{
                      backgroundColor: getStatus(seller.endDate) === 'Expired' ? '#dc3545' : '#28a745',
                      color: 'white',
                      padding: '4px 12px',
                      borderRadius: '4px',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      display: 'inline-block'
                    }}
                  >
                    {getStatus(seller.endDate)}
                  </span>
                </p>
              </div>
          </div>

          {/* Edit Button */}
            <Button
              className="lead-edit-btn"
              onClick={() => {
                handleEditClick(selectedItem);
                onClose();
              }}
              title="Edit"
            >
              Edit
            </Button>
        </div>
      </div>
    </div>
  );
};

export default SelectedRegisteredPopup;
